const calcLineHeights = () => {
	$('.case__question__title__line').each((i, e) => {
		const $this = $(e);
	
		const $parent = $this.closest('.case__question__title');
	
		const coef = $parent.outerHeight() / parseInt($parent.css('line-height'), 10) / 100 * 5
	
		$this.css({
			height: `${$parent.outerHeight() * (0.75 + coef)}px`,
		});
	});
};

calcLineHeights();

$(window).on('load', () => {
	calcLineHeights();
});
